import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import {
  type CustomerFoodFeedback,
  type CustomerFoodFeedbackPreference,
} from '../../../../../../src/types/CustomerFoodFeedback';

export { CustomerFoodFeedbackPreference } from '../../../../../../src/types/CustomerFoodFeedback';

export type Params = {
  customer_id: number;
  requestBody: RequestBody;
};

type RequestBody = {
  order_id: number;
  bundle_id: number | null;
  product_id: number | null;
  pairing_id: number | null;
  food_feedback_id: number;
  preference: CustomerFoodFeedbackPreference;
  tags: [
    {
      tag_id: number;
      preference: CustomerFoodFeedbackPreference;
    }?,
  ];
};

export async function postApiV2CustomersCustomerIdFoodFeedback(params: Params) {
  return await send<CustomerFoodFeedback>({
    path: `/api/v2/customers/${params.customer_id}/food_feedback/`,
    method: 'POST',
    body: params.requestBody,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
      'Content-Type': 'application/json',
    }),
  });
}
